function escapeString (string) {
	return string.replace(/'/g, '\'\'')
}

export default escapeString
